export const logError = window.app.logError;
